import { useEffect, useState } from 'react'
import { fxHitFlash } from '../../assets/index.js'
import { useAnimation } from '../../hooks/useAnimation.js'
import { useAudio } from '../../hooks/useAudio.js'
import { CELL_SIZE } from '../Grid/Cell.js'

interface HitFlashFXProps {
  x: number
  y: number
  /** Callback to apply screen-shake class on the grid container */
  onShake: () => void
  onDone: () => void
}

/**
 * Strike Hit animation: 300ms suspense delay → flash + screen shake → marker.
 * ART_GUIDE_v2 §2.2. Total ~650ms.
 */
export function HitFlashFX({ x, y, onShake, onDone }: HitFlashFXProps) {
  const { phaseTimer, reduceMotion } = useAnimation()
  const { play } = useAudio()
  const [showFlash, setShowFlash] = useState(false)

  useEffect(() => {
    if (reduceMotion) {
      play('strike-hit', 'combat')
      onDone()
      return
    }

    // Phase 1: 300ms suspense delay
    const c1 = phaseTimer(300, () => {
      setShowFlash(true)
      onShake()
      // Fire strike-hit sound in sync with impact flash (per AUDIO.md §2)
      play('strike-hit', 'combat')
      // Phase 2: flash plays for 200ms, then marker fades in
      phaseTimer(350, onDone)
    })

    return c1
  }, [phaseTimer, reduceMotion, onShake, onDone, play])

  if (!showFlash) return null

  return (
    <img
      src={fxHitFlash}
      alt=""
      draggable={false}
      style={{
        position: 'absolute',
        left: x,
        top: y,
        width: CELL_SIZE,
        height: CELL_SIZE,
        pointerEvents: 'none',
        zIndex: 10,
        animation: 'hit-flash 200ms cubic-bezier(0.22,1,0.36,1) forwards',
      }}
    />
  )
}
